import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IpService } from '../services/IpService';

@Injectable()
export class LocalIpInterceptor implements HttpInterceptor {
  constructor(private ipService: IpService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const localIp = this.ipService.getIp();

    if (localIp) {
      req = req.clone({
        setHeaders: {
          'X-Local-IP': localIp
        }
      });
    }

    return next.handle(req);
  }
}
